<template>
  <div class="thumbs">
    <div class="question">{{ questionText }}</div>
    <div class="buttons-container" v-if="!rated">
      <div class="rate-button" :class="[ variant ]" @click="thumbsUp">👍</div>
      <div class="rate-button" :class="[ variant ]" @click="thumbsDown">👎</div>
    </div>
    <div v-else class="thanks-for-answering">
      <div class="thanks-title">תודה! 🙏</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Thumbs',
  data() {
    return {
      rated: false,
    };
  },
  props: {
    questionText: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      default: 'primary',
    },
  },
  methods: {
    thumbsUp() {
      this.$emit('thumbsup');
      this.rated = true;
    },
    thumbsDown() {
      this.$emit('thumbsdown');
      this.rated = true;
    },
  },
};
</script>

<style scoped lang="scss">

@import "~base-ui/src/scss/riseup-colors";

.thumbs {

  .question {
    margin-bottom: 16px;
  }

  .buttons-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .rate-button {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 72px;
      width: 46%;
      font-size: 24px;

      border-radius: 3px;
      cursor: pointer;

      &.primary {
        background-color: $riseup_blue;
      }

      &.secondary {
        background-color: $riseup_white;
        border: 1px solid $riseup_blue;
      }
    }
  }

  .thanks-for-answering {
    padding: 17px;
    line-height: 1.5;
    border-radius: 5px;
    background-color: rgba($riseup_gray_0, 0.4);

    .thanks-title {
      margin-bottom: 3px;
      font-size: 20px;
      font-family: GretaSans;
    }
  }
}

</style>
